<div *ngIf="audioUrl" class="audio-holder">
  <audio controls controlsList="nodownload" class="audio">
    <source [src]="audioUrl" [type]="AUDIO_TYPE">
    <ng-container i18n="General|Audio not supported message@@general-audio-not-supported-message">
      Your browser does not support the audio playback.
    </ng-container>
  </audio>
</div>

<div *ngIf="videoUrl" class="video-holder">
  <video controls controlsList="nodownload" class="video">
    <source [src]="videoUrl" [type]="VIDEO_TYPE">

    <ng-container i18n="General|Video not supported message@@general-video-not-supported-message">
      Your browser does not support the video playback.
    </ng-container>
  </video>
</div>
